import { Pipe, PipeTransform } from "@angular/core";


@Pipe({
    name:'Lz30DeviceInfoFilterPipe'
})
export class Lz30DeviceInfoFilterPipe implements PipeTransform{
    transform(info,nameFilter,emailFilter,mobileNOFilter,serialNoFilter) {
        if(info.length===0 || (nameFilter=='' && emailFilter=='' && mobileNOFilter=='' && serialNoFilter=='')){
            return info;
        }
        else{
            return info.filter((license)=>{
                if(nameFilter!='' && emailFilter!='' && mobileNOFilter!='' && serialNoFilter!=''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.Mobile===mobileNOFilter && license.DeviceSerialNo===serialNoFilter)     
                }
                else if(nameFilter!='' && emailFilter=='' && mobileNOFilter!='' && serialNoFilter!=''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.Mobile===mobileNOFilter && license.DeviceSerialNo===serialNoFilter)
                }
                else if(nameFilter!='' && emailFilter!='' && mobileNOFilter=='' && serialNoFilter!=''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.DeviceSerialNo===serialNoFilter)     
                }
                else if(nameFilter!='' && emailFilter!='' && mobileNOFilter!='' && serialNoFilter==''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.Mobile===mobileNOFilter)     
                }
                else if(nameFilter=='' && emailFilter!='' && mobileNOFilter!='' && serialNoFilter!=''){
                    return (license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.Mobile===mobileNOFilter && license.DeviceSerialNo===serialNoFilter)     
                }
                else if(nameFilter=='' && emailFilter=='' && mobileNOFilter!='' && serialNoFilter!=''){
                    return (license.Mobile===mobileNOFilter && license.DeviceSerialNo===serialNoFilter)     
                }
                else if(nameFilter=='' && emailFilter!='' && mobileNOFilter=='' && serialNoFilter!=''){
                    return (license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.DeviceSerialNo===serialNoFilter)     
                }
                else if(nameFilter=='' && emailFilter!='' && mobileNOFilter!='' && serialNoFilter==''){
                    return (license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.Mobile===mobileNOFilter)     
                }
                else if(nameFilter!='' && emailFilter!='' && mobileNOFilter!='' && serialNoFilter!=''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase()===emailFilter.toLowerCase() && license.Mobile===mobileNOFilter && license.DeviceSerialNo===serialNoFilter)     
                }
                else if(nameFilter!='' && emailFilter=='' && mobileNOFilter=='' && serialNoFilter==''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase())     
                }
                else if(nameFilter!='' && emailFilter=='' && mobileNOFilter=='' && serialNoFilter!=''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.DeviceSerialNo===serialNoFilter)     
                }
                else if(nameFilter!='' && emailFilter=='' && mobileNOFilter!='' && serialNoFilter==''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.Mobile===mobileNOFilter)     
                }
                else if(nameFilter=='' && emailFilter!='' && mobileNOFilter=='' && serialNoFilter==''){
                    return (license.EmailId.toLowerCase()===emailFilter.toLowerCase())     
                }
                else if(nameFilter!='' && emailFilter!='' && mobileNOFilter=='' && serialNoFilter==''){
                    return (license.Name.trim().toLowerCase()===nameFilter.trim().toLowerCase() && license.EmailId.toLowerCase()===emailFilter.toLowerCase())     
                }
                else if(nameFilter=='' && emailFilter=='' && mobileNOFilter!='' && serialNoFilter==''){
                    return (license.Mobile===mobileNOFilter)     
                }
                else if(nameFilter=='' && emailFilter=='' && mobileNOFilter=='' && serialNoFilter!=''){
                    return (license.DeviceSerialNo===serialNoFilter)     
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/lz30/pipes/lz30DeviceInfoFilterPipe.ts